import { A } from '@adornis/base/env-info.js';
import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { html } from 'lit';
import type { School } from '../groups/entities/School.js';

export const martinusMailFooter = (
  school?: NarrowedEntity<
    School,
    {
      name: 1;
      telefonNr: 1;
      homepageURL: 1;
      infoMail: 1;
      adresse: { streetAndNumber: 1; zip: 1; city: 1 };
    }
  >,
) => html`
  <table>
    <tr>
      <td>
        <p>Beste Grüße</p>
      </td>
    </tr>
    <tr>
      <td>
        <p>
          ${school?.name ?? 'Schulgesellschaft St. Martinus gGmbH'}<br />
          ${school?.adresse?.streetAndNumber ?? 'Bischofsplatz 2'}<br />
          ${school?.adresse?.zip ?? '55116'} ${school?.adresse?.city ?? 'Mainz'}
        </p>
      </td>
      <td>
        <p>
          Tel.: ${school?.telefonNr ?? '06131/ 253-220'}<br />
          Mail: ${school?.infoMail ?? 'info@sg-sankt-martinus.de'} <br />
          Homepage:
          <a href="${school?.homepageURL ?? 'https://sg-sankt-martinus.de/'}">
            ${school?.homepageURL ?? 'https://sg-sankt-martinus.de/'}
          </a>
        </p>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <p><a href=${A.absoluteUrl()}>Martinus Portal</a></p>
        <p>
          <a href="https://sg-sankt-martinus.de/">https://sg-sankt-martinus.de/</a><br />
          Schulgesellschaft St. Martinus gGmbH, Sitz der Gesellschaft: Mainz, HRB 51233 Mainz, Steuernr 26/675/17457
          Geschäftsführung: Uwe Brobeil, Andreas Küffner
        </p>
      </td>
    </tr>
    <tr>
      <td>
        <p><a href="https://www.sg-sankt-martinus.de/datenschutzerklaerung/">Datenschutzerklärung</a></p>
      </td>
    </tr>
  </table>
`;
